// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__nGaN9","text":"Tag_text__Xfm1i","button":"Tag_button__bpZWh","maxHeigh":"Tag_maxHeigh__gRDUO"};